export default __webpack_public_path__ + "img/fOkEJMrG.344ac6a8.svg";